module.exports = __webpack_public_path__ + "static/media/popeye_waiting.5ceae378.png";